import axios from "axios";
import {
  pipelineStatsUrl,
  activationFunnelUrl,
  rmPerformanceUrl,
  leadStatusesUrl,
  leadStageUrl,
  leadNoteUrl,
  leadTimelineUrl,
  leadTasksForLeadUrl,
} from "../utils/urls";

export const getPipelineStats = async () =>
  (await axios.get(pipelineStatsUrl))?.data?.data;
export const getActivationFunnel = async () =>
  (await axios.get(activationFunnelUrl))?.data?.data;
export const getRmPerformance = async () =>
  (await axios.get(rmPerformanceUrl))?.data?.data;
export const getLeadStatuses = async () =>
  (await axios.get(leadStatusesUrl))?.data?.data;
export const changeLeadStage = async (lprId, status_id) =>
  (await axios.patch(leadStageUrl(lprId), { status_id }))?.data?.data;
export const addLeadNote = async (lprId, note, kind = "note") =>
  (await axios.post(leadNoteUrl(lprId), { note, kind }))?.data?.data;
export const getLeadTimeline = async (lprId) =>
  (await axios.get(leadTimelineUrl(lprId)))?.data?.data;
export const getLeadTasks = async (lprId) =>
  (await axios.get(leadTasksForLeadUrl(lprId)))?.data?.data;
